import AdyenCheckout from "@adyen/adyen-web";
import "@adyen/adyen-web/dist/adyen.css";
import { InternalAdyenConfig } from "./use-adyen-instance";
import { getAdyenShopperLocale } from "@swo/shared";

const getAdyenConfiguration = (config: InternalAdyenConfig) => ({
  locale: getAdyenShopperLocale(config.locale),
  environment: config.environment,
  clientKey: config.clientKey,
  onAdditionalDetails: config.onAdditionalDetails,
  onChange: config.onChange,
});

export const createAdyenCheckout = (config: InternalAdyenConfig) => {
  return AdyenCheckout(getAdyenConfiguration(config));
};
